

if (!elmApp) {
  var elmApp = Elm.Main.fullscreen();
}


if (!wpi) {
  var wpi = {};
}

if (!wpi.mapmodule) {
  wpi.mapmodule = {};
}




// MAP INIT
elmApp.ports.initMap.subscribe(function(elmdata) {
  setTimeout(function() { //Let the dom get ready

    var mapSettings = elmdata.mapSettings;
    proj4.defs(mapSettings.projection.code, mapSettings.projection.proj4String);

    var map = new ol.Map({
      controls: [
        new ol.control.Rotate(),
        new ol.control.ScaleLine(),
        new ol.control.Zoom()
      ],
      target: elmdata.divName,
      view: new ol.View({
        projection: mapSettings.projection.code,
        extent: [ mapSettings.extent.minx, mapSettings.extent.miny, mapSettings.extent.maxx, mapSettings.extent.maxy],
        center: [ mapSettings.center.x, mapSettings.center.y ],
        zoom: mapSettings.zoom
      })
    });

    var layers = wpi.mapmodule.createLayers(map, elmdata.layers);
    for (var i=0; i<layers.length; i++){
      map.addLayer(layers[i]);
    }

    if (mapSettings.geolocAndBlink[0]) { //geoloc enabled?
      wpi.mapmodule.showPosition(map, mapSettings.geolocAndBlink[1]); //blink enabled?
    }

    // Uncomment if map appears distorted
    // setTimeout(function() {
    //     map.updateSize();
    // }, 65);

    //Send created map data back for storing in elm model
    wpi.mapmodule.onMapCreated(map);
    var mapData = wpi.mapmodule.getMapDataObj(map);

    //Register to map events
    wpi.mapmodule.listenToClick(map);
    wpi.mapmodule.listenToMapMove(map);
    wpi.mapmodule.listenToPointerMove(map);

  }, 65);
});
